import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toApiError, useApi } from '@/shared/api';
import { userKeys } from '../queries';
import { platformRoleChangeError } from './platformRoleError';

export type PlatformRoleChange = 'grant' | 'revoke';

interface Variables {
  id: string;
  change: PlatformRoleChange;
  password: string;
  code: string;
}

/**
 * Vergibt oder entzieht die Plattformrolle. Auch nach einer Ablehnung lädt die Akte neu: ein
 * Konflikt bedeutet, dass sich das Konto inzwischen geändert hat, und die Karte zeigt dann den
 * aktuellen Stand samt Grund.
 */
export function usePlatformRoleChange(onDone: () => void) {
  const api = useApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, change, password, code }: Variables) =>
      change === 'grant'
        ? api.users.grantPlatformAdmin(id, { password, code })
        : api.users.revokePlatformAdmin(id, { password, code }),
    onSuccess: async (_, { change }) => {
      await queryClient.invalidateQueries({ queryKey: userKeys.all });
      toast.success(change === 'grant' ? 'Plattform-Admin vergeben' : 'Plattform-Admin entzogen');
      onDone();
    },
    onError: async (err) => {
      await queryClient.invalidateQueries({ queryKey: userKeys.all });
      toast.error(platformRoleChangeError(await toApiError(err)));
    },
  });
}
